import React, { useEffect, useState } from "react";
import { Row, Col, Form, Select, Modal, notification, Alert } from "antd";
import { ExclamationCircleOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";

import api from "../../../services/api";
import { isObjetoDiffVazio } from "../../../services/funcoes";
import { selectPaginadoActions } from "../../../actions";
import SelectPaginacao from "../../selects/selectPaginacao";
import { useStateValue } from "../../../state";

export default function ModalEditarPDV({ exibirModalPDV, fecharModalPDV, dadosPdv, setDadosPdv }) {

    const [{ ui }, dispatch] = useStateValue();
    const [formulario] = Form.useForm();

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                fecharModalPDV();
            }
        });
    };

    useEffect(() => {
        if (isObjetoDiffVazio(dadosPdv)) {
            formulario.setFieldsValue({ ser_id: dadosPdv.ser_id });
            let lista = [];
            if (!!dadosPdv.ser_id) {
                lista.push({ name: "ser_id", campo: "Id", value: dadosPdv.ser_id });
            }
            if (!!dadosPdv.ser_idnfe) {
                lista.push({ name: "ser_idnfe", campo: "Id", value: dadosPdv.ser_idnfe });
            }
            if (lista.length > 0) {
                dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
            }

        }
    }, [dadosPdv])

    function editarPdv(valores) {
        let dadosPdvTemp = dadosPdv;
        dadosPdvTemp.ser_id = valores.ser_id;
        dadosPdvTemp.ser_idnfe = valores.ser_idnfe;
        api.put(`Pdv/Editar`, dadosPdvTemp).then(
            (res) => {
                notification.success({ message: 'Sucesso!', description: 'Caixa Pdv editado com sucesso!' });
            }
        ).catch(
            error => {
                console.log(error);
                notification.warning({ message: 'Aviso!', description: 'Problema ao editar Caixa Pdv' });
            }
        ).finally(() => { fecharModalPDV(); })
    }

    return (
        <Modal centered
            title="Manutenção do PDV"
            open={exibirModalPDV}
            onOk={() => formulario.submit()}
            onCancel={onCloseModal}
            okText={
                <>
                    <SaveOutlined /> Salvar
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
        >
            <div>
                <Alert
                    message="Atenção"
                    description={
                        <>
                            Para emissão de documentos fiscais utilizando <b>CNPJ</b>, é obrigatório configurar uma <b>Série Fiscal</b> válida. <br />
                            Conforme norma técnica da <b>SEFAZ</b>, somente será permitida a emissão de <b>NF-e (modelo 55)</b> para contribuintes com CNPJ.
                        </>
                    }
                    type="info"
                    showIcon
                    style={{ textAlign: "center", marginBottom: 16 }}
                />
                <Form layout="vertical" name="manutencaoEditarPDV" form={formulario} onFinish={editarPdv}>
                    <Row>
                        <Col span={24}>
                            <Form.Item label="Série Fiscal (NFC-e)" name="ser_id" rules={[{ required: true, message: 'Informe a Série Fiscal NFC-e' }]}>
                                <SelectPaginacao url="SerieFiscal/Listar?CodigoModeloDocFiscal=65&EmitenteDocumento=0"
                                    placeholder="Selecione o Série(NFC-e)"
                                    selecionarRegUnico={"ser_id"}
                                    form={formulario}
                                    nameLabel="ser_serie"
                                    nameValue="ser_id"
                                    disabled
                                    conteudo={
                                        s => (<Select.Option value={s.ser_id} label={s.ser_serie} key={s.ser_id}>{s.ser_id} - {s.ser_serie}</Select.Option>)
                                    }
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Série Fiscal (NF-e)" name="ser_idnfe" rules={[{ required: true, message: 'Informe a Série Fiscal NF-e' }]}>
                                <SelectPaginacao url="SerieFiscal/Listar?CodigoModeloDocFiscal=55&EmitenteDocumento=0"
                                    placeholder="Selecione o Série(NF-e)"
                                    selecionarRegUnico={"ser_idnfe"}
                                    form={formulario}
                                    nameLabel="ser_serie"
                                    nameValue="ser_idnfe"
                                    conteudo={
                                        s => (<Select.Option value={s.ser_id} label={s.ser_serie} key={s.ser_id}>{s.ser_id} - {s.ser_serie}</Select.Option>)
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Modal>
    );
}